import { CustomImage, CustomPageHeader, Text } from '@src/components';
import DraftType from './DraftType';
import LoadBalanceDraftList from './LoadBalanceDraftList';
import NewOrderDraftList from './NewOrderDraftList';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import iconBack from '@src/assets/icons/icon-back.svg';
import '@src/styles/draftOrder/draftOrder.scss';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

const DraftOrder = () => {
  const { draftType } = useSelector((state) => state?.draftOrder);
  const history = useHistory();
  const { isSchool } = useSelector((state) => state?.auth);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNewOrder = () => {
    if (draftType === 1) {
      history.push('/ticket-restaurant/card-orders');
    } else {
      history.push('/ticket-restaurant/balance-upload');
    }
  };

  return (
    <CustomPageHeader
      data-testid="draft-order"
      title={<Text t="drafts" />}
      showBreadCrumb
      showHelpButton
      routes={['ticketRestaurantHeader']}
    >
      <DraftType />
      {!isSchool && draftType === 1 && <NewOrderDraftList />}
      {draftType === 2 && <LoadBalanceDraftList />}

      <div className="draft-order-btn-container">
        <Button id="draftOrder-main-back-btn" className="back-btn" onClick={() => history.goBack()}>
          <CustomImage src={iconBack} />
          <Text t="turnBack" />
        </Button>
        <Button id="draftOrder-main-next-btn" className="next-btn" onClick={handleNewOrder}>
          <Text t="placeNewOrder" />
        </Button>
      </div>
    </CustomPageHeader>
  );
};

export default DraftOrder;
